export const DATA_TEST_IDS = {
  checkoutButton: 'buy-minutes-modal-checkout-button',
  minutesInput: 'buy-minutes-modal-minutes-input',
  viewPlans: 'buy-minutes-modal-view-plans',
};
